import { render } from "./ImageBlock.vue?vue&type=template&id=7c011546&ts=true"
import script from "./ImageBlock.vue?vue&type=script&lang=ts"
export * from "./ImageBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__